import { render, staticRenderFns } from "./NominalCompositionReport.vue?vue&type=template&id=4a8c199f&scoped=true&"
import script from "./NominalCompositionReport.vue?vue&type=script&lang=js&"
export * from "./NominalCompositionReport.vue?vue&type=script&lang=js&"
import style0 from "./NominalCompositionReport.vue?vue&type=style&index=0&id=4a8c199f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c199f",
  null
  
)

export default component.exports